import React from 'react';
import { View, StyleSheet, Text, Platform } from 'react-native';
import { Tile, mappedTitles, mappedIcons, Theme } from 'fitbeat.react-native-components';
import { translate } from 'react-i18next';
import { moderateScale } from 'react-native-size-matters';

class TrackingDashboardHeader extends React.PureComponent {

  render() {
    const { t, tileStyle = {} } = this.props;
    const icon = mappedIcons[this.props.longTermGoal]({}, Theme.WHITE);
    return (
      <Tile customStyle={[styles.container, tileStyle]}>
        <View style={styles.iconContainer}>
          {icon}
        </View>
        <View style={styles.goalHeader}>
          <Text style={styles.title}>{t('longTermFitnessGoal')}</Text>
          <Text style={styles.goal}>{mappedTitles[this.props.longTermGoal].toUpperCase()}</Text>
        </View>
      </Tile>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: 'transparent',
    zIndex: 1,
    borderRadius: 3,
    width: '100%',
    padding: 5,
  },
  goalHeader: {
    flexDirection: 'row',
    marginLeft: 10,
    zIndex: 1,
    alignItems: 'center'
  },
  goal: {
    marginTop: 3,
    fontSize: 20,
    color: Theme.WHITE,
    fontFamily: Theme.Custom600,
  },
  titleContainer: {
    flexDirection: 'row',
  },
  title: {
    fontFamily: Theme.Custom200,
    color: 'white',
    fontSize: 20,
    marginTop: 3,
  },
  iconContainer: {
    marginLeft: 5,
    width: 30,
    height: 30,
  },
});

export default translate(['workoutHistory'])(TrackingDashboardHeader);
